"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Oct 09 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var BindDTO_1 = require("../../model/dto/BindDTO");

var BindDTOConverter_1 = require("./BindDTOConverter");

var CompetitorProductBindDTOConverter_1 = require("./CompetitorProductBindDTOConverter");
/**
 * Implementation of BindDTOConverter
 *
 * @author RV
 */


var BindDTOConverterImpl =
/*#__PURE__*/
function (_BindDTOConverter_1$B) {
  _inherits(BindDTOConverterImpl, _BindDTOConverter_1$B);

  function BindDTOConverterImpl(competitorProductBindDTOConverter) {
    var _this;

    _classCallCheck(this, BindDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BindDTOConverterImpl).call(this));
    _this.competitorProductBindDTOConverter = competitorProductBindDTOConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(BindDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new BindDTO_1.BindDTO(source.internalProductId, conversions.asObjectList(source, 'binds', function (binds) {
        return _this2.competitorProductBindDTOConverter.toObject(binds, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        internalProductId: source.internalProductId,
        binds: conversions.asObjectArray(source, 'binds', function (binds) {
          return _this3.competitorProductBindDTOConverter.toDocument(binds, conversions);
        })
      });
      return result;
    }
  }]);

  return BindDTOConverterImpl;
}(BindDTOConverter_1.BindDTOConverter);

BindDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [CompetitorProductBindDTOConverter_1.CompetitorProductBindDTOConverter])], BindDTOConverterImpl);
exports.BindDTOConverterImpl = BindDTOConverterImpl;